import { AxiosError } from "axios"
import { LoversLiveForeverLogo } from "components/LoversLiveForeverLogo"
import { Alert, Button, TextField } from "components/ui"
import { useAuth } from "hooks/useAuth"
import { useState } from "react"
import { Link } from "react-router-dom"

export const LoginPage = () => {
  const { login } = useAuth()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)

    try {
      await login(email, password)
    } catch (err: unknown | AxiosError) {
      if (err instanceof AxiosError) {
        setError(err.response?.data?.errorMessage || "Failed to login")
      } else {
        setError("Failed to login")
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <Link to="/">
            <LoversLiveForeverLogo className="mx-auto h-20 w-auto" />
          </Link>
          <h2 className="mt-8 text-center text-2xl/9 font-bold tracking-tight text-gray-900 dark:text-white">
            Login to your account
          </h2>
        </div>

        <div className="sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white dark:bg-gray-900 px-6 py-12 sm:px-12">
            {error && (
              <Alert variant="error" className="mb-4">
                {error}
              </Alert>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <TextField
                label="Email address"
                id="email"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />

              <TextField
                label="Password"
                id="password"
                name="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                labelAction={
                  <Link
                    to="/forgot-password"
                    className="text-sm/6 font-semibold text-primary-600 hover:text-primary-500"
                  >
                    Forgot password?
                  </Link>
                }
              />

              <div>
                <Button type="submit" fullWidth isLoading={isLoading}>
                  {isLoading ? "Signing in..." : "Sign in"}
                </Button>
              </div>
            </form>
          </div>

          <p className="mt-10 text-center text-sm/6 text-gray-500 dark:text-gray-400">
            Not a member?{" "}
            <Link
              to="/signup"
              className="font-semibold text-primary-600 hover:text-primary-500"
            >
              Create a free account ❤️
            </Link>
          </p>
        </div>
      </div>
    </>
  )
}
